import React, { useState, useEffect } from "react";
import text from "strings/text";
import RemoveItemModal from "components/RemoveItemModal";
import AddRoleModal from "components/AddRoleModal";
import "./RoleSection.scss";
import ColorPicker from "components/ColorPicker";
import { getMemberCountForRole } from "./duck/helpers";
import { Mixpanel } from "helpers/Mixpanel";

export function RoleSectionComponent({
  roles,
  locationId,
  deleteRoleDispatch,
  loadLocationRolesDispatch,
  addRoleDispatch,
  updateRoleDispatch,
  selectedRoleId,
  onSelectRole,
  members,
}) {
  const [showRemoveRoleModal, setShowRemoveRoleModal] = useState(false);
  const [roleToDelete, setRoleToDelete] = useState(null);
  const [showAddRoleModal, setShowAddRoleModal] = useState(false);

  useEffect(() => {
    if (locationId) {
      loadLocationRolesDispatch(locationId);
    }
  }, [locationId, loadLocationRolesDispatch]);

  const handleDeleteRoleClick = (e, role) => {
    e.stopPropagation();
    setShowRemoveRoleModal(true);
    setRoleToDelete(role);
  }

  const handleAddRoleClick = (e) => {
    setShowAddRoleModal(true);
  }

  const handleAddRole = (roleName, colorCode) => {
    if (roleName && colorCode) {
      Mixpanel.track('Create role', { role_name: roleName, color_code: colorCode });
      addRoleDispatch(roleName, colorCode, locationId);
      setShowAddRoleModal(false);
    }
  }

  const handleColorSelect = (role, newColor) => {
    Mixpanel.track('Update role color', { role_id: role.id, role_name: role.name, color_code: newColor });
    updateRoleDispatch(role.id, newColor, locationId);
  }

  const handleConfirmDeleteRole = () => {
    if (!roleToDelete) return;
    Mixpanel.track('Delete role', { role_id: roleToDelete.id, role_name: roleToDelete.name });
    deleteRoleDispatch(roleToDelete.id, locationId);
  }

  const handleRoleRowClick = (role) => {
    if (onSelectRole) {
      onSelectRole(role.id);
    }
  }

  const roleRow = (role) => {
    const isSelected = selectedRoleId === role.id;
    const memberCount = getMemberCountForRole(members, role.id);
    const rowClassName = `edit-group-item role-row-selectable${isSelected ? ' role-row-selected' : ''}`;

    return (
       <div className={rowClassName} key={'edit-'+role.id} onClick={() => handleRoleRowClick(role)}>
         <div className="role-name">
            <label className="role-item-button">
              <span className="role-color-indicator" style={{ backgroundColor: `#${role.color_code || '0A84FF'}` }} />
              {role.name}
              <span className="role-member-count">({memberCount})</span>
            </label>
         </div>
         <div className="role-actions" onClick={(e) => e.stopPropagation()}>
           <ColorPicker
             selectedColor={role.color_code}
             onColorSelect={(color) => handleColorSelect(role, color)}
           />
           <button className="remove-role" onClick={(e) => {handleDeleteRoleClick(e, role)}}><img src="/icons/delete-corner.svg" alt="Delete"/></button>
         </div>
      </div>);
  }

  return (
    <div className="user-group" style={{marginBottom: '16px'}}>
      <label className="section-label">{text.roles}</label>
      <label className="section-explain">{text.roleExplain}</label>

        <div className="user-group-list">
          {roles.map((role) => ( roleRow(role)))}
        </div>

      <div>
         <button className="blue-btn" onClick={handleAddRoleClick}> {text.addNewRole}</button>
      </div>

      {showRemoveRoleModal &&
      <RemoveItemModal removeItem={handleConfirmDeleteRole}
                            closeModal={(e) => setShowRemoveRoleModal(false)}
                            title={text.removeRole(roleToDelete?.name)}
                            explain={text.removeRoleExplain(roleToDelete?.name)} />}

      {showAddRoleModal &&
      <AddRoleModal
        addRole={handleAddRole}
        closeModal={(e) => setShowAddRoleModal(false)}
        title={text.createRole}
        explain={text.createRoleExplain}
        roles={roles}
      />}
    </div>
  );
}
export default RoleSectionComponent;

